<template>
  <div 
    class="review-button-widget"
    :style="{
      backgroundColor: widget.backgroundColor || 'transparent',
      padding: widget.padding || '2rem',
      textAlign: widget.alignment || 'center'
    }"
  >
    <div class="review-button-content" :class="`text-${widget.alignment || 'center'}`">
      <!-- Title -->
      <h3 v-if="widget.title" class="review-title mb-2">
        {{ widget.title }}
      </h3>
      
      <!-- Subtitle -->
      <p v-if="widget.subtitle" class="review-subtitle text-muted mb-4">
        {{ widget.subtitle }}
      </p>
      
      <!-- Button -->
      <button
        @click="openReviewModal"
        class="btn"
        :class="[
          `btn-${widget.buttonStyle || 'primary'}`,
          `btn-${widget.buttonSize || 'lg'}`
        ]"
        :style="buttonStyles"
      >
        <i v-if="widget.buttonIcon" :class="widget.buttonIcon" class="me-2"></i>
        {{ widget.buttonText || 'Γράψτε Κριτική' }}
      </button>
    </div>
    
    <!-- Review Submission Modal -->
    <ReviewSubmissionModal 
      v-if="showModal"
      :is-open="showModal"
      @close="showModal = false"
      @submitted="handleReviewSubmitted"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import type { ReviewButtonWidget } from '@/types/pagebuilder'
import ReviewSubmissionModal from '@/components/ReviewSubmissionModal.vue'

interface Props {
  widget: ReviewButtonWidget
}

const props = defineProps<Props>()

const showModal = ref(false)

const openReviewModal = () => {
  showModal.value = true
}

const handleReviewSubmitted = () => {
  showModal.value = false
  // Show success message or notification
  alert('Ευχαριστούμε! Η κριτική σας υποβλήθηκε επιτυχώς και θα εγκριθεί σύντομα.')
}

const buttonStyles = computed(() => {
  const styles: Record<string, string> = {}
  
  // Apply custom colors if provided (with !important to override bootstrap)
  if (props.widget.customBackgroundColor) {
    styles.backgroundColor = `${props.widget.customBackgroundColor} !important`
  }
  if (props.widget.customTextColor) {
    styles.color = `${props.widget.customTextColor} !important`
  }
  if (props.widget.customBorderColor) {
    styles.borderColor = `${props.widget.customBorderColor} !important`
    styles.border = `2px solid ${props.widget.customBorderColor} !important`
  }
  
  return styles
})
</script>

<style scoped>
.review-button-widget {
  position: relative;
}

.review-button-content {
  max-width: 600px;
  margin: 0 auto;
}

.review-title {
  font-size: 2rem;
  font-weight: 700;
  color: #2c3e50;
  margin-bottom: 0.5rem;
}

.review-subtitle {
  font-size: 1.1rem;
  margin-bottom: 1.5rem;
}

.btn {
  transition: all 0.3s ease;
  font-weight: 600;
  letter-spacing: 0.5px;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.btn i {
  font-size: 1.1em;
}
</style>
